import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ModalEvent } from '../types/modal-event';
import {
  AlertModalParams,
  CodeModalParams,
  ConfirmModalParams,
  EditPhotoModalParams,
  FeedbackModalParams,
  FileUploadModalParams,
  UploadTaskModalParams,
} from '../types/modal-params';

/**
 * App modal service.
 * Most of the modals are controlled by this service globally.
 */
@Injectable({
  providedIn: 'root',
})
export class ModalService {
  // Emitter of modal events
  public modalEvent = new BehaviorSubject<ModalEvent<any> | null>(null);

  constructor() {}

  showAlert(params: AlertModalParams) {
    this.modalEvent.next({
      type: 'alert',
      params,
    });
  }

  showConfirmModal(params: ConfirmModalParams) {
    this.modalEvent.next({
      type: 'confirm',
      params,
    });
  }

  showCodeModal(params: CodeModalParams) {
    this.modalEvent.next({
      type: 'code',
      params,
    });
  }

  showEditPhotoModal(params: EditPhotoModalParams) {
    this.modalEvent.next({
      type: 'editPhoto',
      params,
    });
  }

  showFeedbackModal(params: FeedbackModalParams) {
    this.modalEvent.next({
      type: 'feedback',
      params,
    });
  }

  showHelpModal(params: FeedbackModalParams) {
    this.modalEvent.next({
      type: 'help',
      params,
    });
  }

  showFileUploadModal(params: FileUploadModalParams) {
    this.modalEvent.next({
      type: 'fileUpload',
      params,
    });
  }

  showUploadTaskModal(params: UploadTaskModalParams) {
    this.modalEvent.next({
      type: 'uploadTask',
      params,
    });
  }

  closeModal() {
    this.modalEvent.next(null);
  }
}
